<template>
  <div class="wrapper">
    <div class="main">
      <div class="main--inner">
        <Header />
        <Banner />
        <div class="container">
          <div class="container--inner">
            <div class="brief">
              <div class="brief--inner">
                <div class="ts">
                  <img
                    :src="require(`@/assets/img/main/img-title-ts.png`)"
                    alt=""
                  />
                </div>
                <div class="brief--title">
                  <img
                    :src="require(`@/assets/img/main/img-title-brief.png`)"
                    alt=""
                  />
                </div>
                <div class="brief--box">
                  <div class="brief--info">
                    <div class="brief--info--inner">
                      <span class="brief--info--text">
                        三只松鼠杯休闲食品创新大赛是由三只松鼠股份有限公司联合中国食品科学技术学会共同主办，集产品创意挖掘、人才培养为一体，致力于鼓励年轻人创新，助力年轻人成长，挖掘创意产品，推动休闲食品行业技术创新，为年轻人筑造一个享受食品创意乐趣的舞台！今年首次开展
                      </span>
                      <span class="brief--info--sign"></span>
                    </div>
                  </div>
                  <div class="brief--video">
                    <div class="brief--video--box">
                      <video
                        :poster="require(`@/assets/img/main/poster3.png`)"
                        controls
                        loop
                      >
                        <source
                          src="https://res.vod.3songshu.com/32c7a13ae4114c468cb8ecf31b2f1999/1b578009c80b4ec9a9e7853d1e2d6cb9-2aec1d59916312b9322d6a5c6c044986-hd.mp4"
                        />
                      </video>
                    </div>
                  </div>
                  <div class="xiaojian">
                    <div class="xiaojian--inner">
                      <img
                        class="animate__animated animate__infinite wave_animate"
                        :src="require(`@/assets/img/main/xiaojian.png`)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="school">
              <div class="bg-thunder"></div>
              <div class="school--inner">
                <div class="school--title">
                  <img
                    :src="require(`@/assets/img/main/img-title-school.png`)"
                    alt=""
                  />
                </div>
                <div class="school--box">
                  <div class="school--box--inner">
                    <div class="school--direct" v-if="direct">
                      <div class="direct--title">
                        <img
                          :src="require(`@/assets/img/school/direct.png`)"
                          alt=""
                        />
                      </div>
                      <div class="direct--list">
                        <div
                          class="direct--item"
                          :key="`school_${index}`"
                          v-for="(item, index) in schoolList"
                        >
                          <div
                            class="direct--logo"
                            :style="{
                              backgroundImage:
                                'url(' +
                                require(`@/assets/img/school/${item.img}.png`) +
                                ')'
                            }"
                          ></div>
                          <div class="direct--name">
                            <p class="direct--name--text">
                              {{ item.name }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="direct--next">
                        <div class="icon--next" @click="handleNext"></div>
                      </div>
                    </div>
                    <div class="not--direct" v-else>
                      <img
                        :src="require(`@/assets/img/school/not-direct.png`)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="xiaoku">
                  <div class="cartoon--inner">
                    <img
                      class="animate__animated animate__infinite wave_animate"
                      :src="require(`@/assets/img/main/xiaoku.png`)"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="awards">
              <div class="bg-thunder"></div>
              <div class="awards--inner">
                <div class="awards--title">
                  <img :src="require(`@/assets/img/main/process.png`)" alt="" />
                </div>

                <div class="process--box"></div>
                <div class="awards--title">
                  <img
                    :src="require(`@/assets/img/main/img-title-awards.png`)"
                    alt=""
                  />
                </div>
                <div class="awards--box">
                  <div class="awards--box--inner">
                    <div class="awards--content">
                      <div class="awards--content--inner">
                        <div class="awards--names">
                          <div class="item">
                            <div class="item--inner bold">
                              <div class="awards--name">
                                <span>
                                  初赛
                                </span>
                              </div>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">初赛</p>
                                  <p class="detail--sign">
                                    松鼠坚果大礼包/队+证书/人
                                  </p>
                                  <p class="detail--count">入围60个团队</p>
                                  <p class="detail--bottom">松鼠大礼包/队</p>
                                  <p class="detail--bottom">
                                    证书/人(根据决赛成绩统一发放)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item--inner bold">
                              <div class="awards--name">
                                <span>
                                  决赛
                                </span>
                              </div>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">决赛</p>
                                  <div class="final--items">
                                    <div class="final--item">
                                      <p class="detail--sign">
                                        ¥30,000
                                      </p>
                                      <p class="detail--count">第一名（1队）</p>
                                      <p class="detail--bottom">
                                        奖金30000元/队
                                      </p>
                                      <p class="detail--bottom">
                                        三只松鼠offer
                                      </p>
                                      <p class="detail--bottom">
                                        证书/人
                                      </p>
                                    </div>
                                    <div class="final--item">
                                      <p class="detail--sign">
                                        ¥20,000
                                      </p>
                                      <p class="detail--count">第二名（2队）</p>
                                      <p class="detail--bottom">
                                        奖金20000元/队
                                      </p>
                                      <p class="detail--bottom">
                                        证书/人
                                      </p>
                                    </div>
                                    <div class="final--item">
                                      <p class="detail--sign">
                                        ¥10,000
                                      </p>
                                      <p class="detail--count">第三名（3队）</p>
                                      <p class="detail--bottom">
                                        奖金10000元/队
                                      </p>
                                      <p class="detail--bottom">
                                        证书/人
                                      </p>
                                    </div>
                                    <div class="final--item">
                                      <p class="detail--sign">
                                        ¥10,000
                                      </p>
                                      <p class="detail--count">
                                        最佳改良作品（1队）
                                      </p>
                                      <p class="detail--bottom">
                                        奖金10000元/队
                                      </p>
                                      <p class="detail--bottom">
                                        证书/人
                                      </p>
                                    </div>
                                  </div>
                                  <p class="remark">
                                    备注：最佳改良作品只针对命题类。
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item--inner">
                              <div class="awards--name">
                                <span>
                                  单项作品
                                </span>
                              </div>
                              <span class="awards--count">(7队)</span>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">单项奖</p>
                                  <div
                                    class="final--items final--items--single"
                                  >
                                    <div class="final--item">
                                      <p class="detail--sign">
                                        ¥5,000
                                      </p>
                                      <div class="single-wrap">
                                        <div class="single--count">6队</div>
                                        <div class="single--content">
                                          <div class="single--works">
                                            <p class="single--works--item">
                                              <span class="single--sign"
                                                >最佳视频作品</span
                                              >、最佳营销方案作品
                                            </p>
                                            <p class="single--works--item">
                                              最佳风味作品、最佳包装设计作品
                                            </p>
                                            <p class="single--works--item">
                                              最佳创意作品、最佳团队风采作品
                                            </p>
                                          </div>
                                          <p class="detail--bottom">
                                            5000元/队
                                          </p>
                                          <p class="detail--bottom">证书/人</p>
                                          <p class="single--remark">
                                            备注：最佳视频作品与决赛其他奖项不冲突。
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                      class="final&#45;&#45;item"-->
                                    <!--                                      style="margin-left: 20px;"-->
                                    <!--                                    >-->
                                    <!--                                      <p class="detail&#45;&#45;sign">-->
                                    <!--                                        ¥10,000-->
                                    <!--                                      </p>-->
                                    <!--                                      <div class="single-wrap">-->
                                    <!--                                        <div class="single&#45;&#45;count">1队</div>-->
                                    <!--                                        <div class="single&#45;&#45;content">-->
                                    <!--                                          <div class="single&#45;&#45;works">-->
                                    <!--                                            <p class="single&#45;&#45;works&#45;&#45;item">-->
                                    <!--                                              <span class="single&#45;&#45;sign"-->
                                    <!--                                                >最佳改良作品</span-->
                                    <!--                                              >-->
                                    <!--                                            </p>-->
                                    <!--                                          </div>-->
                                    <!--                                          <p class="detail&#45;&#45;bottom">-->
                                    <!--                                            10000元/队-->
                                    <!--                                          </p>-->
                                    <!--                                          <p class="detail&#45;&#45;bottom">证书/人</p>-->
                                    <!--                                        </div>-->
                                    <!--                                      </div>-->
                                    <!--                                    </div>-->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item--inner">
                              <div class="awards--name">
                                <div class="awards--name--inner">
                                  <span>
                                    优秀组织
                                  </span>
                                  <span>高校</span>
                                </div>
                              </div>
                              <span class="awards--count">(4个)</span>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">优秀组织高校</p>
                                  <p class="detail--sign">
                                    ¥5000
                                  </p>
                                  <p class="detail--count">4个</p>
                                  <p class="detail--bottom">5000元/校</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item--inner">
                              <div class="awards--name">
                                <span>
                                  优胜作品
                                </span>
                              </div>
                              <span class="awards--count">(8队)</span>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">优胜作品</p>
                                  <p class="detail--sign">
                                    ¥1000
                                  </p>
                                  <p class="detail--count">8队</p>
                                  <p class="detail--bottom">1000元/队</p>
                                  <p class="detail--bottom">证书/人</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="item--inner">
                              <div class="awards--name">
                                <span>
                                  提名作品
                                </span>
                              </div>
                              <span class="awards--count">(20队)</span>
                              <i class="icon--right"></i>
                              <div class="awards--popup">
                                <div class="awards--detail">
                                  <p class="detail--name">提名作品</p>
                                  <p class="detail--sign"></p>
                                  <p class="detail--count">20队</p>
                                  <p class="detail--bottom">证书/人</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="awards--remark">
                      备注：为获得第一名的参赛团队队长提供三只松鼠股份有限公司offer一份，
                      该团队其他成员获得三只松股份有限公司校招终面卡；
                      对于所有获奖团队成员均可获得在三只松鼠股份有限公司实习的机会。
                    </div>
                  </div>
                </div>
                <div class="xiaomei">
                  <div class="cartoon--inner">
                    <img
                      class="animate__animated animate__infinite wave_animate"
                      :src="require(`@/assets/img/main/xiaomei.png`)"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="qrcode">
              <div class="explain">
                （以上内容最终解释权归三只松鼠股份有限公司和中国食品科学技术学会所有）
              </div>
              <div class="qrcode--title">~更多详情请扫码关注哦~</div>
              <div class="qrcode--img">
                <img :src="require(`@/assets/img/main/qrcode.png`)" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header";
import Banner from "./Banner";
export default {
  name: "index",
  components: { Header, Banner },
  data() {
    return {
      direct: true,
      schoolList: [
        {
          name: "江南大学",
          img: "1"
        },
        {
          name: "中国农业大学",
          img: "2"
        },
        {
          name: "南昌大学",
          img: "3"
        },
        {
          name: "西北农林科技大学",
          img: "4"
        },
        {
          name: "合肥工业大学",
          img: "5"
        },
        {
          name: "浙江工商大学",
          img: "6"
        },
        {
          name: "华中农业大学",
          img: "7"
        },
        {
          name: "大连工业大学",
          img: "8"
        },
        {
          name: "哈尔滨商业大学",
          img: "9"
        },
        {
          name: "安徽工程大学",
          img: "10"
        }
      ]
    };
  },
  methods: {
    handleNext() {
      this.direct = false;
      const st = setTimeout(() => {
        this.direct = true;
        clearTimeout(st);
      }, 3000);
    }
  }
};
</script>

<style scoped lang="less">
@import "./style.less";
</style>
